import { Navigate } from "react-router-dom";

import { DefaultLayout } from "core/layouts";
import Dashboard from "pages/dashboard";
import ApprovedLibraries from 'pages/libraries/approved';
import Approvals from "pages/libraries/approvals/";
import BookingsPage from "pages/bookings/";
import PendingRefundPage from "pages/bookings/PendingRefunds";
import StudentsPage from "pages/students";
import VendorsPage from "pages/vendors";
import CouponsPage from "pages/coupons";
import AmenitiesPage from "pages/amenities";
import StudentsFeedbackPage from "pages/feedback/student";
import VendorFeedbackPage from "pages/feedback/vendor";
import LibraryReviewsPage from "pages/feedback/reviews";
import AdminUsersPage from 'pages/admin/users';
import BannerImagesPage from 'pages/settings/banner-images';
import ConfigurationPage from "pages/settings/configurations";
import LibraryTypesPage from "pages/libraries/types";
import IncentivesPage from "pages/incentives";
import PayoutsPage from "pages/payouts";
import NotificationsPage from "pages/notifications";
import Complaints from "pages/complaints";
import SubscriptionsPage from "pages/subscriptions";
import RolesPage from "pages/roles";
import PermissionsPage from "pages/permissions";
import InProgressPage from "pages/libraries/in-progress";
import VendorDashboardPage from "pages/dashboard/vendor";
import BookingsBulkUpload from "pages/bookings/BulkUpload";
import ActivityLogPage from "pages/activity-logs";

const AppRoutes = [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Navigate to="/overview/" replace={true} />
  },
  // {
  //   path: "/termsofuse",
  //   exact: true,
  //   layout: LayoutWithHeader,
  //   component: TermsOfUse
  // },
  // {
  //   path: "/privacy",
  //   exact: true,
  //   layout: LayoutWithHeader,
  //   component: Privacy
  // },
  // {
  //   path: "/about-us",
  //   exact: true,
  //   layout: LayoutWithHeader,
  //   component: AboutUs
  // },
  {
    path: "/overview/",
    layout: DefaultLayout,
    component: Dashboard,
    enableAuth: true,
  },
  {
    path: "/libraries/approved/",
    layout: DefaultLayout,
    component: ApprovedLibraries,
    enableAuth: true,
  },
  {
    path: "/libraries/approvals/",
    layout: DefaultLayout,
    component: Approvals,
    enableAuth: true,
  },
  {
    path: "/libraries/bookings/all/",
    layout: DefaultLayout,
    component: BookingsPage,
    enableAuth: true,
  },
  {
    path: "/libraries/bookings/pending-refund/",
    layout: DefaultLayout,
    component: PendingRefundPage,
    enableAuth: true,
  },
  {
    path: "/libraries/bookings/bulk-upload/",
    layout: DefaultLayout,
    component: BookingsBulkUpload,
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: "/students/",
    layout: DefaultLayout,
    component: StudentsPage,
    enableAuth: true,
    // roles: ['admin', 'manager']
  },
  {
    path: "/vendors/",
    layout: DefaultLayout,
    component: VendorsPage,
    enableAuth: true,
    // roles: ['admin', 'manager']
  },
  {
    path: "/coupons/",
    layout: DefaultLayout,
    component: CouponsPage,
    enableAuth: true,
  },
  {
    path: "/libraries/amenities/",
    layout: DefaultLayout,
    component: AmenitiesPage,
    enableAuth: true,
  },
  {
    path: "/feedback/student/",
    layout: DefaultLayout,
    component: StudentsFeedbackPage,
    enableAuth: true,
    // roles: ['admin', 'manager']
  },
  {
    path: "/feedback/vendor/",
    layout: DefaultLayout,
    component: VendorFeedbackPage,
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: "/feedback/library-reviews/",
    layout: DefaultLayout,
    component: LibraryReviewsPage,
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: "/admin/users/",
    layout: DefaultLayout,
    component: AdminUsersPage,
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: "/settings/banner-images/",
    layout: DefaultLayout,
    component: BannerImagesPage,
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: "/settings/configurations/",
    layout: DefaultLayout,
    component: ConfigurationPage,
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: "/libraries/type/",
    layout: DefaultLayout,
    component: LibraryTypesPage,
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: '/incentives/',
    layout: DefaultLayout,
    component: IncentivesPage,
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: '/payouts/',
    layout: DefaultLayout,
    component: PayoutsPage,
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: '/notifications/',
    layout: DefaultLayout,
    component: NotificationsPage, 
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: '/complaints/',
    layout: DefaultLayout,
    component: Complaints, 
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: '/subscriptions/',
    layout: DefaultLayout,
    component: SubscriptionsPage, 
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: '/roles/',
    layout: DefaultLayout,
    component: RolesPage, 
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: '/permissions/',
    layout: DefaultLayout,
    component: PermissionsPage, 
    enableAuth: true,
    // roles: ['admin', 'manager', 'employee']
  },
  {
    path: "/libraries/in-progress/",
    layout: DefaultLayout,
    component: InProgressPage,
    enableAuth: true,
  },
  {
    path: "/dashboard/vendor/",
    layout: DefaultLayout,
    component: VendorDashboardPage,
    enableAuth: true,
  },
  {
    path: "/activity-log/",
    layout: DefaultLayout,
    component: ActivityLogPage,
    enableAuth: true,
  },
];
export default AppRoutes;
